import axiosInstance from '../api/axios';

export const authService = {
    getCsrfToken: async () => {
        try {
            await axiosInstance.get('/get-csrf-token/');
        } catch (error) {
            console.error('Error obteniendo token CSRF:', error);
        }
    },

    login: async (credentials) => {
        try {
            // Primero obtener el token CSRF
            await authService.getCsrfToken();
            
            // Luego hacer el login
            const response = await axiosInstance.post('/login/', credentials);
            return response.data;
        } catch (error) {
            console.error('Error en login:', error);
            throw error;
        }
    },

    requestPasswordReset: async (email) => {
        try {
            await authService.getCsrfToken();
            const response = await axiosInstance.post('/usuarios/auth/password-reset/', { email });
            return response.data;
        } catch (error) {
            console.error('Error requesting password reset:', error);
            throw error;
        }
    },

    confirmPasswordReset: async (data) => {
        try {
            await authService.getCsrfToken();
            const response = await axiosInstance.post('/usuarios/auth/password-reset/confirm/', data);
            return response.data;
        } catch (error) {
            console.error('Error confirming password reset:', error);
            throw error;
        }
    },

    verifyEmail: async (data) => {
        try {
            const response = await axiosInstance.post('/usuarios/auth/verify-email/', data);
            return response.data;
        } catch (error) {
            console.error('Error verifying email:', error);
            throw error;
        }
    }
}; 